import React from 'react';

const StatCard = ({
  icon,
  label,
  value,
  variant = 'primary',
  valueVariant,
  loading = false
}) => {
  const iconClass = `card-icon icon-${variant}`;
  const valueClass = valueVariant ? `card-value value-${valueVariant}` : 'card-value';

  return (
    <div className={`stat-card ${loading ? 'loading' : ''}`}>
      <div className={iconClass}>
        <i className="material-icons">{icon}</i>
      </div>
      <div className="card-content">
        <div className="card-label">{label}</div>
        {loading ? (
          <div className={valueClass}></div>
        ) : (
          <div className={valueClass}>{value || 'N/A'}</div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
